export default __webpack_public_path__ + "static/media/cross.275675d3.svg";